export default "__VITE_ASSET__K7opp$eZ__"